import Grid from '@mui/material/Grid'
import { AlarmIcon, CloseIcon } from 'assets/icons'
import IconButton from 'components/buttons/IconButton'
import PopupSectionRow from 'components/popup/PopupSectionRow'
import { formatDuration } from 'date-fns'
import { EventReminder } from 'types/api/changes'

import { t } from 'i18next'
import i18n from 'i18n'
import CustomEventRecurrencePopup from 'components/popups/eventInfo/CustomEventRecurrencePopup'
import { useState } from 'react'
import { set } from 'cypress/types/lodash'
import { PopupInstance } from 'components/popup/Popup'
import { ex } from '@fullcalendar/core/internal-common'

interface RemindersListProps {
  reminders: EventReminder[]
  setReminders: (reminders: EventReminder[]) => void
}
const humanizeDuration = require('humanize-duration')

export default function RemindersList(props: RemindersListProps) {
  const [showCustom, setShowCustom] = useState<number | undefined>(undefined)

  return (
    <Grid container flexDirection={'column'} display={'flex'}>
      {(props.reminders ?? [])
        ?.sort((a, b) => Number(a.offset) - Number(b.offset))
        ?.map((reminder, index) => {
          const removeReminder = () => {
            props.setReminders(
              props.reminders.filter((rem) => rem.offset != reminder.offset)
            )
          }

          let duration = ''

          try {
            duration = humanizeDuration(reminder.offset * 1000, {
              language:
                i18n.language.length > 2
                  ? i18n.language.slice(0, 2)
                  : i18n.language
            })
          } catch (error) {
            duration = humanizeDuration(reminder.offset * 1000)
          }

          return (
            <CustomEventRecurrencePopup
              key={reminder.offset}
              open={showCustom === reminder.offset}
              setOpen={(b: boolean) => {
                if (!b) setShowCustom(undefined)
              }}
              reminders={props.reminders}
              setReminders={props.setReminders}
              edititngReminder={props.reminders.find(
                (rem) => rem.offset === showCustom
              )}
            >
              <span style={{ width: '100%' }}>
                <PopupSectionRow
                  icon={<AlarmIcon />}
                  cursor="default"
                  action={() => {
                    console.log(reminder.offset)
                    setShowCustom(reminder.offset)
                  }}
                  title={
                    reminder.offset === 0
                      ? t('onTime')
                      : `${t('timeBefore', {
                          time: duration
                        })}`
                  }
                  value={
                    <IconButton size="xs" onClick={removeReminder}>
                      <CloseIcon />
                    </IconButton>
                  }
                />
              </span>
            </CustomEventRecurrencePopup>
          )
        })}
    </Grid>
  )
}
